import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveNomeEvento({ commit }, data) {
      try {
        return await api.post('/eventos/nomes', data)
      } catch (error) {
        throw error
      }
    },

    async saveNomeEventoFromFile({ commit }, data) {
      try {
        return await api.post('/eventos/nomes/file', data)
      } catch (error) {
        throw error
      }
    },

    async getNomesEventos({ commit }) {
      try {
        const response = await api.get('/eventos/nomes')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getNomeEvento({ commit }, nomeId) {
      try {
        const response = await api.get(`/eventos/nomes/${nomeId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateNomeEvento({ commit }, data) {
      try {
        return await api.put(`/eventos/nomes/${data.id}`, data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
